import React from 'react'
import DateRangePicker from 'rsuite/DateRangePicker'
import { getDate, getMonth, getYear } from 'date-fns'

import moment from 'utils/momentInstanse'

const Picker = ({
  handleSetDateRange,
  values = { start_timestmp: null, end_timestmp: null },
}) => {
  const start_timestmp = values.start_timestmp
    ? moment.unix(values.start_timestmp).toDate()
    : null
  const end_timestmp = values.end_timestmp
    ? moment.unix(values.end_timestmp).toDate()
    : null

  const handleChangeDateRange = (dateRange) => {
    const [start, end] = dateRange

    handleSetDateRange({
      value: {
        start_timestmp: moment()
          .set('year', getYear(start))
          .set('months', getMonth(start))
          .set('date', getDate(start))
          .startOf('day')
          .unix(),
        end_timestmp: moment()
          .set('year', getYear(end))
          .set('months', getMonth(end))
          .set('date', getDate(end))
          .endOf('day')
          .unix(),
      },
    })
  }

  const classNameDatePickerWithoutValue =
    !start_timestmp || !end_timestmp ? 'no_value' : ''

  return (
    <div className="date-container">
      <DateRangePicker
        ranges={[]}
        onChange={handleChangeDateRange}
        character=" - "
        cleanable={false}
        placeholder={'From - To'}
        value={[start_timestmp, end_timestmp]}
        className={`date_picker_wrap ${classNameDatePickerWithoutValue}`}
        format="dd MMM yy"
        showOneCalendar={true}
        disabledDate={DateRangePicker.afterToday()}
        limitEndYear={0}
        readOnly={false}
        renderValue={([start, end]) => {
          return `${moment(start).format('DD MMM YY')} - ${moment(end).format(
            'DD MMM YY'
          )}`
        }}
      />
    </div>
  )
}

export default Picker
